module.exports = __webpack_public_path__ + "img/xmas-bg.2ca8420.webp";